import Phaser from 'Phaser'
import Dino from './dino.js'

const config = {
    scale: {
        mode: Phaser.Scale.FIT,
        parent: 'phaser-example',
        width: 1280,
        height: 480
    },
    parent: 'dino',
    backgroundColor: '#eaf3f2',
    title: 'Dino',
    pixelArt: true,
    physics: {
        default: 'arcade',
        arcade: {
            gravity: {
                y:3000
            }
        }
    },
    scene: [
        Dino
    ]
};

new Phaser.Game(config);